// A simple dice roller — roll up to two dice to comply with curse/card conditions
// (Gambler's Feet, Endless Tumble, Spotty Memory, casting-cost rolls, etc.).
// Pure client-side; opens a modal anywhere it's wired.
const FACES = ["", "⚀", "⚁", "⚂", "⚃", "⚄", "⚅"];

export function openDice(initial: 1 | 2 = 2) {
  document.querySelector("#jl-dice")?.remove();
  let count: 1 | 2 = initial;
  let vals: number[] = [];
  let rolling = false;
  const el = document.createElement("div");
  el.id = "jl-dice";
  el.className = "h-modal";
  el.addEventListener("click", (e) => { if (e.target === el) el.remove(); });
  document.body.appendChild(el);

  function roll() {
    if (rolling) return;
    rolling = true;
    let ticks = 0;
    const iv = setInterval(() => {
      vals = Array.from({ length: count }, () => 1 + Math.floor(Math.random() * 6));
      render();
      if (++ticks >= 8) { clearInterval(iv); rolling = false; render(); }
    }, 55);
  }
  function render() {
    el.innerHTML = `<div class="h-modal-box dice-box">
      <div class="h-modal-title">🎲 Roll dice</div>
      <div class="dice-seg">${([1, 2] as const).map((n) => `<button data-dc="${n}" class="${count === n ? "on" : ""}">${n} ${n === 1 ? "die" : "dice"}</button>`).join("")}</div>
      <div class="dice-faces ${rolling ? "rolling" : ""}">${(vals.length ? vals : Array(count).fill(0)).map((v) => `<span class="die ${v ? "" : "muted"}">${FACES[v] || "⚅"}</span>`).join("")}</div>
      ${vals.length === 2 && !rolling ? `<div class="dice-total">Total: <b>${vals[0] + vals[1]}</b></div>` : `<div class="dice-total">&nbsp;</div>`}
      <div class="h-modal-acts"><button class="ghost" id="dice-close">Close</button><button class="primary green" id="dice-roll">${vals.length ? "Roll again" : "Roll"}</button></div>
    </div>`;
    el.querySelectorAll<HTMLButtonElement>("[data-dc]").forEach((b) => b.addEventListener("click", () => { if (rolling) return; count = +b.dataset.dc! as 1 | 2; vals = []; render(); }));
    el.querySelector("#dice-roll")?.addEventListener("click", roll);
    el.querySelector("#dice-close")?.addEventListener("click", () => el.remove());
  }
  render();
}
